
const m = window.require("embercom/lib/inbox/constants");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
